export const US_STATES: Array<string> = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
] as const;

export const US_STATES_SERVICED: Array<string> = ['KY', 'MD', 'NY', 'OH', 'FL', 'PA'] as const;

export enum ORDER_STATUSES {
  CANCELLED = 'CANCELLED',
  CONTACTING_PATIENT = 'CONTACTING_PATIENT',
  DONE = 'DONE',
  IN_PROGRESS_WITH_SUPPLIER = 'IN_PROGRESS_WITH_SUPPLIER',
  NEW_ORDER = 'NEW_ORDER',
  ON_HOLD_WITH_SUPPLIER = 'ON_HOLD_WITH_SUPPLIER',
  PENDING_CH_FIX = 'PENDING_CH_FIX',
  PENDING_CLINICAL = 'PENDING_CLINICAL',
  PENDING_ACCEPTANCE = 'PENDING_ACCEPTANCE',
  PROCESSING = 'PROCESSING',
  SUPPLIER_REVIEWING_CHANGES = 'SUPPLIER_REVIEWING_CHANGES',
  ERROR = 'ERROR',
  TELEHEALTH_UPCOMING = 'TELEHEALTH_UPCOMING',
  TELEHEALTH_NEEDS_RESCHED = 'TELEHEALTH_NEEDS_RESCHED',
  TELEHEALTH_COMPLETED = 'TELEHEALTH_COMPLETED',
  CHASING_CLINICALS = 'CHASING_CLINICALS',
  POST_VISIT_ACTIONS_COMPLETED = 'POST_VISIT_ACTIONS_COMPLETED',
  PENDING_REROUTE = 'PENDING_REROUTE',
  PENDING_CANCEL = 'PENDING_CANCEL',
  SUPPLIER_SHIPPED = 'SUPPLIER_SHIPPED',
  SUPPLIER_COMPLETED = 'SUPPLIER_COMPLETED',
  CANT_REACH_PATIENT = 'CANT_REACH_PATIENT',
  TELEHEALTH_ON_HOLD = 'TELEHEALTH_ON_HOLD',
  BILLING = 'BILLING',
  PENDING_AUTHORIZATION = 'PENDING_AUTHORIZATION',
  CONFIRM_ORDER = 'CONFIRM_ORDER',
  PREPARING_SHIPMENT = 'PREPARING_SHIPMENT',
  SEND_TO_CANDID = 'SEND_TO_CANDID',
  SEND_TO_LUMINA = 'SEND_TO_LUMINA',
  // adding so zod recognizes them
  BILLING_COMPLETED = 'BILLING_COMPLETED',
  READY_FOR_CONTACT = 'READY_FOR_CONTACT',
  PENDING_SUPPLIER_ACCEPTANCE = 'PENDING_SUPPLIER_ACCEPTANCE',
}

export function isClosedOrderStatus(status: ORDER_STATUSES): boolean {
  return [
    ORDER_STATUSES.DONE,
    ORDER_STATUSES.SUPPLIER_COMPLETED,
    ORDER_STATUSES.SUPPLIER_SHIPPED,
    ORDER_STATUSES.BILLING,
    ORDER_STATUSES.CANCELLED,
  ].includes(status);
}

export type ORDER_ABILITIES =
  | 'EDIT_ITEMS'
  | 'EDIT_DOCUMENTS'
  | 'EDIT_PATIENT'
  | 'EDIT_INSURANCE'
  | 'EDIT_PROVIDER'
  | 'EDIT_RX_EXPIRATION_DATE'
  | 'REQUEST_CANCEL'
  | 'MESSAGE_SUPPLIER'
  | 'INPUT_TIME_SCHEDULED'
  | 'CHANGE_TIME_SCHEDULED'
  | 'INPUT_TIME_COMPLETED';

export enum TELEHEALTH_ORDER_ERRORS {
  PATIENT_NO_SHOW = 'PATIENT_NO_SHOW',
  PATIENT_RESCHEDULE = 'PATIENT_RESCHEDULE',
  DOCTOR_NO_SHOW = 'DOCTOR_NO_SHOW',
  DOCTOR_RESCHEDULE = 'DOCTOR_RESCHEDULE',
  CANCELED = 'CANCELED',
  OTHER = 'OTHER',
}
